module.exports = __webpack_public_path__ + "img/5.71b9ef0f.png";